<template>
    <div v-if="dataBO.legalSect" :class="['legalMentions', compClass]">
        <p class="h2" v-html="dataBO.legalSect.legalTitle"></p>
        <div class="content" v-html="dataBO.legalSect.legalContent">Lorem ipsum dolor sit amet.</div>
    </div>
</template>
<script>
    import { mapState } from 'vuex'

    export default {
        name: 'LegalMentions',
        props: {
            compClass: { type: String, default: ''},
        },
        computed:{
            ...mapState(['dataBO']),
        }
    }
</script>
<style lang="scss" scoped>
    .legalMentions{
        margin: 4rem 0;

        & > .h2{
            @include mixin_textContent(.875rem, .875rem, $medium, $grayDarkCol);
            margin-bottom: 1rem;
        }

        & > .content{
            display: grid;
            gap: 1rem;

            @include mixin_textContent(.75rem, 1.187rem, $regular, $grayLightCol);
        }
    }

    @include respond-to(maxLarge){
        .resumePage{ margin-bottom: 12rem; }
    }

    @include respond-to(large){
        .legalMentions{
            margin: 7rem 0;
        }
    }
</style>
